import { createSvgIcon } from '@material-ui/core/utils';

/**
 * Type of component properties.
 */
type SvgIconProps = {
  name: string;
  children: JSX.Element | JSX.Element[];
  viewBox?: string;
  className?: string;
  rotate?: number;
  style?: Record<string, unknown>;
  transform?: string;
};

/**
 * Type of component that use svgIcon wrapper component.
 */
export type SvgIconComponentProps = {
  viewBox?: string;
  color?: string;
  className?: string;
  onClick?: (evt: React.SyntheticEvent<any>) => void | Promise<void>;
  rotate?: number;
  style?: Record<string, unknown>;
  fontSize?: 'inherit' | 'default' | 'small' | 'large';
  tabIndex?: number;
};

/**
 * Wrapper component for svg icons.
 * Creates svg icon with material-ui helper function, and passes
 * down props.
 *
 * @param {SvgIconProps} props - component props.
 *
 * @returns {JSX.Element}
 */
export const SvgIcon = (props: SvgIconProps): JSX.Element => {
  const { name, viewBox = '0 0 24 24', children, rotate, style = {} } = props;
  const SvgIconComponent = createSvgIcon(children, name);

  if (rotate != null) {
    style.transform = `rotateZ(${rotate}deg)`;
  }

  return <SvgIconComponent viewBox={viewBox} {...props} style={style} />;
};
